'use strict';

var Config = {
    // Endpoints references
    'authentication_server': 'https://elektraauth.domoticalabs.com:443',
    'services_server': 'https://elektracloud.domoticalabs.com:443',
    'authentication_type': 'standard', // IoT or standard
    'user_client_id': '',
    'user_client_secret': '',

    // Endpoints mqtt
    'mqtt_endpoint': 'wss://elektracloud.domoticalabs.com:8884', // wss://cloudbeta.domoticalabs.com:8884
    'mqtt_endpoint_cordova': 'mqtt://elektracloud.domoticalabs.com:1883', // mqtts://cloudbeta.domoticalabs.com:8883

    // Standard authentication
    'user_email': null,
    'user_secret': null,
    'user_access_token': null,
    'user_refresh_token': null,
    'user_expiration_token': null,

    // Debug status
    'debug': false,

    // Save data in localStorage
    'save_local_storage': false
};

export default Config;



// WEBPACK FOOTER //
// ./src/config.js